module.exports = __webpack_public_path__ + "img/7-ilpakamanioMASY2_thumb.60ae8e03.jpg";